import { getUrl } from 'helpers';
import ReactSlider from 'react-slider';
import styled from 'styled-components';

export const Slider = styled(ReactSlider as any)`
    .thumb {
        background-image: url(${getUrl('/assets/images/truck.svg')});
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;
        cursor: grab;
        height: 40px;
        outline: none;
        top: -10px;
        width: 56px;

        &:active {
            cursor: grabbing;
        }
    }

    .track {
        background: #fff;
        border-radius: 999px;
        border: 4px solid #fff;
        box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.102);
        padding: 5px;
    }

    .track-0 {
        background: linear-gradient(270deg, #f9c132 3.56%, rgba(249, 193, 50, 0.29556) 58.31%, rgba(249, 193, 50, 0) 100%) !important;
    }
`;